module.exports = __webpack_public_path__ + "static/media/dashedcircle.bda2b558.png";